<div class="auth-body h-screen relative">
  <div class="absolute bottom-0 w-full flex justify-center flex-row">
    <div class="p-4 w-full bg-white">
      <p class="text-center text-[#797C83] footer-branding"> A Product by <b><a target="_blank" href="https://purple.lk/" class=" text-[#797C83] hover:font-[#640D5C]" style="">Purple Software</a></b></p>
    </div>
  </div>
  <div class="grid lg:grid-cols-2 h-full">
    <div class="bg-slate-200 hidden lg:flex items-center justify-end">
      <div class="bg-white h-4/6 w-8/12 p-1 drop-shadow-lg">
        <img
          class="h-full w-full object-cover"
          src="https://images.unsplash.com/photo-1607990276968-b2bd88933b94?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
          alt="" />
      </div>
    </div>
    <div class="lg:bg-primary flex items-center justify-start">
      <div
        class="lg:bg-white w-full lg:h-4/6 lg:w-8/12 drop-shadow-lg flex items-center justify-center">
        <div class="w-8/12 lg:w-7/12 text-center lg:text-start">
          <nz-card class="border-0">
            <form nz-form [formGroup]="forgotPasswordForm">
              <h3>Forgot Password</h3>
              <p>
                Enter your email address associated with your account. We'll
                send an email with instructions.
              </p>
              <div class="flex flex-col items-stretch my-4">
                <nz-form-item class="mb-3">
                  <nz-form-control class="w-full" [nzErrorTip]="emailError">
                    <nz-input-group nzPrefixIcon="user">
                      <input
                        nz-input
                        formControlName="email"
                        placeholder="Email" />
                    </nz-input-group>
                  </nz-form-control>
                  <ng-template #emailError>
                    <span>Please enter a email</span>
                  </ng-template>
                </nz-form-item>
              </div>
              <button
                nz-button
                nzType="primary"
                [disabled]="forgotPasswordForm.invalid"
                nzBlock
                (click)="sendEmail()">
                Send
              </button>
              <div *ngIf="msg.icon === 'show'">
                <nz-alert
                  class="mt-2"
                  [nzType]="msg.type"
                  [nzMessage]="msg.message"
                  nzShowIcon></nz-alert>
              </div>
            </form>
            <div class="mt-8">
              <a routerLink="/auth/login">Back to Login</a>
            </div>
          </nz-card>
        </div>
      </div>
    </div>
  </div>
</div>
